import React, { useState } from 'react';

const CasesAddModal = ({
  show,
  onClose,
  formData,
  onChange,
  onSave,
  isEditMode,
  isLoading
}) => {
  const [validatedFields, setValidatedFields] = useState({
    case_name: false,
    case_type: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mark all fields as validated when submitting
    const allFieldsValidated = {
      case_name: true,
      case_type: true
    };
    setValidatedFields(allFieldsValidated);

    // Check if all required fields are filled
    const isFormValid = Object.keys(allFieldsValidated).every(
      field => !!formData[field]
    );

    if (isFormValid) {
      onSave();
    }
  };

  const handleBlur = (fieldName) => {
    if (!validatedFields[fieldName]) {
      setValidatedFields(prev => ({
        ...prev,
        [fieldName]: true
      }));
    }
  };

  const shouldShowValidation = (fieldName) => {
    return validatedFields[fieldName] && !formData[fieldName];
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex="-1"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h5 className="modal-title">
              {isEditMode ? 'Edit Case' : 'Add Case'}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Case Name</label>
                    <input
                      type="text"
                      className={`form-control ${shouldShowValidation('case_name') ? 'is-invalid' : ''}`}
                      name="case_name"
                      value={formData.case_name || ''}
                      onChange={onChange}
                      onBlur={() => handleBlur('case_name')}
                      required
                      disabled={isLoading}
                    />
                    {shouldShowValidation('case_name') && (
                      <div className="invalid-feedback">Case name is required</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Case Type</label>
                    <input
                      type="text"
                      className={`form-control ${shouldShowValidation('case_type') ? 'is-invalid' : ''}`}
                      name="case_type"
                      value={formData.case_type || ''}
                      onChange={onChange}
                      onBlur={() => handleBlur('case_type')}
                      required
                      disabled={isLoading}
                    />
                    {shouldShowValidation('case_type') && (
                      <div className="invalid-feedback">Case type is required</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn mb-1 waves-effect waves-light btn-outline-danger"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn mb-1 waves-effect waves-light btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {isEditMode ? 'Updating...' : 'Saving...'}
                    </>
                  ) : isEditMode ? 'Update Case' : 'Save Case'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasesAddModal;